export const SM_SCREEN = 640
export const MD_SCREEN = 768
export const LG_SCREEN = 1024
export const XL_SCREEN = 1280